import React from 'react';

function HourGlassIcon({ width = 16, height = 19, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 16 19">
      <g fillRule="evenodd">
        <path d="M12.715,1.5 C12.639,2.377 12.43,3.298 12.138,4.188 L3.696,4.188 C3.404,3.299 3.195,2.378 3.119,1.5 L12.715,1.5 Z M15.042,17.417 L14.213,17.417 C13.986,14.676 12.642,11.263 10.701,9.5 C12.642,7.736 13.986,4.324 14.213,1.583 L15.042,1.583 C15.48,1.583 15.834,1.229 15.834,0.792 C15.834,0.354 15.48,0 15.042,0 L0.792,0 C0.355,0 0,0.354 0,0.792 C0,1.229 0.355,1.583 0.792,1.583 L1.621,1.583 C1.848,4.324 3.193,7.737 5.133,9.5 C3.193,11.263 1.848,14.676 1.621,17.417 L0.792,17.417 C0.355,17.417 0,17.771 0,18.208 C0,18.646 0.355,19 0.792,19 L15.042,19 C15.48,19 15.834,18.646 15.834,18.208 C15.834,17.771 15.48,17.417 15.042,17.417 Z" />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default HourGlassIcon;
